export default "__VITE_ASSET__Byox_S0s__"